var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.devmode)?_c('div',[_c('div',{staticClass:"sticky"},[_vm._v(" This server is in development mode ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }